import ActionTypes from '../Actions/ActionTypes';

let initialState = {
    allUsers: [],
    allUsersPagination: null,
    dashboardData: {
        revenueByAds: 0,
        revenueByYardSales: 0,
        totalUser: 0,
        totalYardSales: 0,
    },

    userDetails: {},
    userYardSales: [],
    userYardSalesPagination: null,
};

const DashboardReducer = (state = initialState, action) => {
    switch (action.type) {

        case ActionTypes.GET_DASHBOARD_DATA:
            state = {
                ...state,
                allUsers: action.payload?.users?.data,
                allUsersPagination: action.payload?.users,
                dashboardData: {
                    revenueByAds: action.payload?.revenueByAds,
                    revenueByYardSales: action.payload?.revenueByYardSales,
                    totalUser: action.payload?.totalUser,
                    totalYardSales: action.payload?.totalYardSales,
                },

            };
            break;

        case ActionTypes.CLEAR_DASHBOARD_DATA:
            state = {
                ...state,
                allUsers: {},
                allUsersPagination: null,
                dashboardData: {
                    revenueByAds: 0,
                    revenueByYardSales: 0,
                    totalUser: 0,
                    totalYardSales: 0,
                },
            };
            break;

        case ActionTypes.GET_USER_DETAILS:
            state = {
                ...state,
                userDetails: action.payload?.user,
                userYardSales: action.payload?.yardSales?.data,
                userYardSalesPagination: action.payload?.yardSales,
            };
            break;

        case ActionTypes.CLEAR_USER_DETAILS:
            state = {
                ...state,
                userDetails: {},
                userYardSales: [],
                userYardSalesPagination: null,
            };
            break;


        case ActionTypes.DEACTIVATE_USER_YARDSALE:
            const ex_yardsales = [...state.userYardSales];
            let index = ex_yardsales.findIndex(item => item.id === action.payload.id);
            let updatedYardsale = { ...state.userYardSales[index], status: 'cancelled' };
            ex_yardsales.splice(index, 1, updatedYardsale);
            state = {
                ...state,
                userYardSales: ex_yardsales,
                userYardSalesPagination: state.userYardSalesPagination,
            };
            break;




        default:
            break;
    }
    return state;
};

export default DashboardReducer;
